import Vue from 'vue'
import Vuex from 'vuex'
import {getUserInteractions} from '@/helpers/api/interactions'
import {getProjectRequest, isCurrentProjectRequest} from '@/helpers/projectContext'

Vue.use(Vuex)

const initialState = () => ({
	interactions: [],
	loading: false,
	error: null,
	projectId: null,
	selectedUserId: null,
	currentPage: 1,
	lastPage: 1,
	total: 0,
	perPage: 20,
	from: null,
	to: null
})

const store = new Vuex.Store({
	state: initialState(),
	mutations: {
		setLoading(state, status){
			state.loading = status
		},
		setError(state, error){
			state.error = error
		},
		setSelectedUserId(state, userId){
			state.selectedUserId = userId
		},
		setCurrentPage(state, page){
			state.currentPage = page
		},
		setInteractionsResponse(state, response){
			state.interactions = response.interactions || []
			state.projectId = response.project_id || state.projectId
			state.currentPage = response.current_page || 1
			state.lastPage = response.last_page || 1
			state.total = response.total || 0
			state.perPage = response.per_page || state.perPage
			state.from = response.from || null
			state.to = response.to || null
		},
		resetForProject(state){
			Object.assign(state, initialState())
		}
	},
	actions: {
		async getInteractions(context, query = {}){
			const projectId = query.project_id
			if(!projectId) return

			const request = getProjectRequest(projectId)
			const page = query.page || context.state.currentPage || 1
			const perPage = query.per_page || context.state.perPage || 20
			const selectedUserId = query.user_id !== undefined
				? query.user_id
				: context.state.selectedUserId
			const data = {
				project_id: projectId,
				page,
				per_page: perPage
			}

			if(selectedUserId !== null && selectedUserId !== undefined && selectedUserId !== ''){
				data.user_id = selectedUserId
			}

			context.commit('setSelectedUserId', selectedUserId || null)
			context.commit('setLoading', true)
			context.commit('setError', null)

			try {
				const response = await getUserInteractions(data)
				if(isCurrentProjectRequest(request.projectId, request.generation) && response.code === 200){
					context.commit('setInteractionsResponse', Object.assign({}, response, {project_id: projectId}))
				}
			} catch (error) {
				if(isCurrentProjectRequest(request.projectId, request.generation)){
					context.commit('setError', error)
				}
			} finally {
				if(isCurrentProjectRequest(request.projectId, request.generation)){
					context.commit('setLoading', false)
				}
			}
		},
		resetInteractions(context){
			context.commit('resetForProject')
		}
	}
})

export default store
